module.exports = __webpack_public_path__ + "img/icn_whatsapp.3226d48d.svg";